module.exports = __webpack_public_path__ + "static/img/4.554688db.png";